// eslint-disable-next-line import/no-cycle
import AuthService from "../../service";

const miniType = {
  getTCDCMiniType(page,search) {
    return AuthService.get(`/branch/mini_type?page=${page}&search=${search}`);
  },
  showTCDCMiniType(id) {
    console.log(`/branch/mini_type/${id}`);
    return AuthService.get(`/branch/mini_type/${id}`);
  },
  createTCDCMiniType(data) {
    return AuthService.post("/branch/mini_type", data);
  },
  updateTCDCMiniType(id, data) {
    return AuthService.put(`/branch/mini_type/${id}`, data);
  },
  deleteTCDCMiniType(id) {
    return AuthService.delete(`/branch/mini_type/${id}`);
  },
  getAllMiniType() {
    return AuthService.get("/branch/mini_type_all");
  }
};
export default miniType;
